import { Button, Box, Divider, Typography } from '@mui/material'
import type { GridColDef, GridEventListener, MuiEvent } from '@mui/x-data-grid'
import { isNil } from 'lodash'

interface PaginationModel {
  pageSize: number
  page: number
}

const MobileRow = ({
  row,
  columns,
}: {
  row: any
  columns: readonly GridColDef[]
}) => {
  return columns.map((col: any, index: number) => {
    const {
      field,
      valueGetter,
      valueFormatter,
    }: {
      field: string
      valueGetter?: (params: { row: object }) => any
      valueFormatter?: (params: { value: any }) => string
    } = col

    const variant = index === 0 ? 'h3' : 'body1'
    const color = index !== 0 ? '#292B2699' : '#2C2C27'

    let value = row[field]
    if (valueGetter) {
      value = valueGetter({ row })
    }
    if (valueFormatter) {
      value = valueFormatter({ value })
    }

    return (
      <Typography variant={variant} color={color} key={col.field}>
        {value}
      </Typography>
    )
  })
}

export const MobileDataTable = ({
  columns,
  rows,
  onRowClick,
  customButtonText,
  mobileCustomButtonClicked,
  paginationModel,
  onPaginationModelChange,
  totalCount,
}: {
  columns: readonly GridColDef[]
  rows: any
  onRowClick?: GridEventListener<'rowClick'>
  customButtonText?: string
  mobileCustomButtonClicked?: any
  paginationModel?: PaginationModel
  onPaginationModelChange?: any
  totalCount?: number
}) => {
  return (
    <>
      {rows.map((row: any) => (
        <>
          <Box
            padding={2}
            onClick={(
              event: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>
            ) => {
              if (!isNil(onRowClick)) {
                onRowClick(row, event, {})
              }
            }}
            key={row.id}
          >
            <MobileRow row={row} columns={columns} />
            {customButtonText ? (
              <Button
                variant="contained"
                onClick={(e) => {
                  e.preventDefault()
                  mobileCustomButtonClicked(row)
                }}
              >
                {customButtonText}
              </Button>
            ) : null}
          </Box>
          <Divider />
        </>
      ))}
      {paginationModel ? (
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              disabled={paginationModel.page === 0} // Disable if on the first page
              onClick={() => {
                onPaginationModelChange({
                  pageSize: paginationModel.pageSize,
                  page: paginationModel.page - 1,
                })
              }}
            >
              Previous
            </Button>
            <Button
              variant="contained"
              disabled={
                paginationModel.page >=
                Math.ceil((totalCount ?? 0) / paginationModel.pageSize) - 1 // Disable if on the last page
              }
              onClick={() => {
                onPaginationModelChange({
                  pageSize: paginationModel.pageSize,
                  page: paginationModel.page + 1,
                })
              }}
            >
              Next
            </Button>
          </Box>
          <Typography variant="body2" color="textSecondary">
            {`Page ${paginationModel.page + 1} of ${Math.ceil(
              (totalCount ?? 0) / paginationModel.pageSize
            )}`}
          </Typography>
        </Box>
      ) : null}
    </>
  )
}
